module.exports = __webpack_public_path__ + "img/login-bg.b4b6857.png";